module.exports = __webpack_public_path__ + "img/3f97d75.jpg";